import script from "./msgTip.vue?vue&type=script&setup=true&name=msgTip&lang=js"
export * from "./msgTip.vue?vue&type=script&setup=true&name=msgTip&lang=js"

import "./msgTip.vue?vue&type=style&index=0&id=4d20763e&scoped=true&lang=css"

import exportComponent from "D:\\Jawsro\\company\\hujing\\v3\\hujing_pro_h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d20763e"]])

export default __exports__